import { getRequestWithAuth, postRequestWithAuth } from "../api";

export const getDocument = async (sessionId: string) => {
  const response = await getRequestWithAuth(
    `/api/v1/analysisDocument/getDocument/${sessionId}`
  );
  return response;
};

export const updateDocument = async (
  sessionId: string,
  contentHtml: string
) => {
  const response = await postRequestWithAuth(
    `/api/v1/analysisDocument/updateDocument`,
    {
      session_id: sessionId,
      content_html: contentHtml,
    },
    {
      headers: {
        Accept: "application/json",
      },
    }
  );

  return response;
};

export const createBlankDocument = async (sessionId: string) => {
  const response = await postRequestWithAuth(
    `/api/v1/analysisDocument/createBlankDocument`,
    {
      session_id: sessionId,
    },
    {
      headers: {
        Accept: "application/json",
      },
    }
  );

  return response;
};

export const getDocumentAIStatus = async (sessionId: string) => {
  const response = await getRequestWithAuth(
    `/api/v1/analysisDocument/getDocumentAIStatus/${sessionId}`
  );
  return response;
};

export const generateDocumentWithAI = async (sessionId: string, userPrompt: string) => {
  const response = await postRequestWithAuth(
    `/api/v1/analysisDocument/generateDocumentWithAI`,
    {
      session_id: sessionId,
      user_prompt: userPrompt,
    },
    {
      headers: {
        Accept: "application/json",
      },
    }
  );
  return response;
};

export const exportDocx = async (sessionId: string, tiptapJson: any) => {
  const response = await postRequestWithAuth(
    `/api/v1/analysisDocument/exportDocx`,
    {
      session_id: sessionId,
      tiptap_json: tiptapJson,
    },
    {
      headers: {
        Accept: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      },
      responseType: "blob",
    }
  );
  return response;
};

export const exportPdf = async (sessionId: string, tiptapJson: any) => {
  const response = await postRequestWithAuth(
    `/api/v1/analysisDocument/exportPdf`,
    {
      session_id: sessionId,
      tiptap_json: tiptapJson,
    },
    {
      headers: {
        Accept: "application/pdf",
      },
      responseType: "blob",
    }
  );
  return response;
};